import "./App.css";
import { Toaster } from "./components/ui/sonner";
import { useSmoothScroll } from "./hooks/useSmoothScroll";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { EditorialMarquee } from "./components/site/EditorialMarquee";
import { GalleryIntro } from "./components/site/GalleryIntro";
import { About } from "./components/site/About";
import { Manifesto } from "./components/site/Manifesto";
import { Heritage } from "./components/site/Heritage";
import { Sandalwood, Saffron } from "./components/site/Products";
import { Inquiry } from "./components/site/Inquiry";
import { Footer } from "./components/site/Footer";

function App() {
  useSmoothScroll();

  return (
    <div className="App bg-[#12100E] min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <GalleryIntro />
        <About />
        <Inquiry />
        <Sandalwood />
        <Saffron />
        <Heritage />
        <Manifesto />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1A1714",
            border: "1px solid #2C2621",
            color: "#F4EFE6",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
